function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var RBSP = /*#__PURE__*/function () {
  function RBSP() {
    _classCallCheck(this, RBSP);
  }
  _createClass(RBSP, null, [{
    key: "EBSP2RBSP",
    value:
    /**
     * convert EBSP to RBSP
     * @param {Uint8Array} data
     * @returns {Uint8Array}
     * @constructor
     */
    function EBSP2RBSP(data) {
      return data.filter(function (el, idx) {
        if (idx < 2) {
          return true;
        } else {
          return !(data[idx - 2] === 0 && data[idx - 1] === 0 && el === 3);
        }
      });
    }

    /**
     * @param {Uint8Array} data
     * @constructor
     */
  }, {
    key: "EBSP2SODB",
    value: function EBSP2SODB(data) {
      var lastByte = data[data.byteLength - 1];
      if (lastByte && lastByte === 128) {
        return data.slice(0, data.byteLength - 1);
      }
      return data;
    }
  }]);
  return RBSP;
}();
export default RBSP;